import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CustomRegistrationService } from '../custom-registration.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { LOCAL_STORAGE } from 'src/app/shared';

@Component({
  selector: 'app-user-registration',
  templateUrl: './user-registration.component.html',
  styleUrls: ['./user-registration.component.scss'],
})
export class UserRegistrationComponent implements OnInit {
  header: string;
  formData: any;
  creditInvoice: string;
  dummyData: any;
  akamaiRegistered: any;
  isNonBuyingPhysician: boolean = this.sharedService.getLocalStorage(
    LOCAL_STORAGE.REGISTRATION.NON_BUYING_PHYSICIAN_REGISTRATION
  );

  constructor(
    private readonly accountRegService: CustomRegistrationService,
    private readonly cdr: ChangeDetectorRef,
    protected sharedService: SharedService
  ) {}

  ngOnInit(): void {
    this.header = 'accountInformation';
    this.creditInvoice = 'invoiceTable';

    this.accountRegService.sectionChange.subscribe((sectionDetails) => {
      this.header = sectionDetails.header;
      if (sectionDetails?.form) {
        this.formData = sectionDetails.form;
        this.akamaiRegistered = sectionDetails?.akamaiRegistered;
      }
      if (sectionDetails.header === 'confirmation') {
        this.formData = sectionDetails?.msgData;
      }
      this.cdr.detectChanges();
    });
  }
}
